import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import * as actions from './actions'
import * as getters from './getters'
import aghOrder from './modules/order.info' 
import user from './modules/user.info' 
import birthday from './modules/birthday.info' 
import customize from './modules/customize.info' 

const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
    actions,
    getters,
    modules: {
        aghOrder,
        user,
        birthday,
        customize
    },
    strict: debug
})
